<template>
  <div class="main">
    <div class="titlefont">
      <div class="titleAnimation">
        <div class="title">
          {{ itemAdvantage.title }}
        </div>
        <div class="desc">{{ itemAdvantage.about }}</div>
      </div>
    </div>
    <div class="conMain">
      <div class="con">
        <div class="left leftShow">
          <!-- 电商 -->
          <div>
            <img :src="itemAdvantage.image[1].url" />
          </div>
          <!-- end -->
          <!-- 平面 -->
          <!-- <div v-if="subject.name === '平面设计'">
            <img src="../img/sjvs.png" />
          </div> -->
          <!-- end -->
          <!-- ui -->
          <!-- <div class="uiBox" v-if="subject.name === 'UI设计'">
            <img src="../img/UIvs.png" />
          </div> -->
          <!-- <div class="leftLogo">
            <img :src="itemAdvantage.logo" />
          </div>
          <ul>
            <li v-for="(item, index) in itemAdvantage.list" :key="index">
              <div class="icon"></div>
              <div class="text">
                <div class="tit">{{ item.title }}</div>
                <p v-for="(val, i) in item.description" :key="i">
                  {{ val }}
                </p>
              </div>
            </li>
          </ul> -->
        </div>
        <div class="right rightShow">
          <!-- 电商 -->
          <div>
            <img :src="itemAdvantage.image[0].url" />
          </div>
          <!-- end -->
          <!-- 平面 -->
          <!-- <div v-if="subject.name === '平面设计'">
            <img src="../img/sjvsa.png" />
          </div> -->
          <!-- end -->
          <!-- ui -->
          <!-- <div class="uiBox" v-if="subject.name === 'UI设计'">
            <img src="../img/UIvsa.png" />
          </div> -->
          <!-- <div class="leftLogo">其他</div>
          <ul>
            <li v-for="(item, index) in itemAdvantage.otherList" :key="index">
              <div class="icon"></div>
              <div class="text">
                <div class="tit">{{ item.title }}</div>
                <p v-for="(val, i) in item.description" :key="i">
                  {{ val }}
                </p>
              </div>
            </li>
          </ul> -->
        </div>
        <div class="vsTip shrinkShow"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    itemAdvantage: {
      type: Object,
      default: () => {},
    },
    subject: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>